module.exports = __webpack_public_path__ + "static/img/sbzmr_varazdinske_toplice.712cf9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/sbzmr_varazdinske_toplice.jpg
// module id = ktDD
// module chunks = 0